module.exports = __webpack_public_path__ + "2020celebration/img/ewm.d8d4378c.png";